import React, {Component} from 'react';
import LogoPic from "../../assets/images/logo.png";
import API from '../../services/API';
import Toast from '../Common/Toast';
import { toast } from 'react-toastify';

class Login extends Component {
    state = {
        mobile : "",
        buttonStatus: "disabled",
        buttonText : "دریافت کد تایید",
        loading: "d-none",
        message: ""
    }
    onInputChange = (event) => {
        const mobile = event.target.value;
        if (mobile.length >= 12) {
            return false;
        }
        if (mobile[0] === '0' && mobile[1] === '9' && mobile.length === 11) {
            this.setState({buttonStatus: ""})
        } else {
            this.setState({buttonStatus: "disabled"})
        }
        this.setState({mobile});
    }
    onButtonClick =  () => {
        const buttonText  = "";
        const  loading = "d-inline-block";
        const buttonStatus = "disabled";
        this.setState({buttonText,loading,buttonStatus });
        const mobile = this.state.mobile;
        const request = {
            'mobile' : mobile,
            'i_am_driver' : 1
        }
         API.sendOTP(request)
             .then((response) => {
                 toast.success(response.user_message);
                 window.localStorage.setItem("mobile", this.state.mobile);
                 window.localStorage.setItem("new_user",response.results.new_user);
                 if (typeof response.results.otp !== 'undefined') {
                     window.localStorage.setItem("otp",response.results.otp);
                 }
                 setTimeout (() => {
                     this.props.history.push("/verify");
                 },1500)
                 })
             .catch((error) => {
                 toast.error(error.response.data.user_message);
             });
    }
    render() {
        return (
            <React.Fragment>
                <Toast  />
                <section className="container-fluid ">
                    <div className="row">
                        <div className="col-12 pt-2 ">
                            <div className="card border-1 rounded-more vh100">
                                <div className="col-12 pt-2">
                                    <img src={LogoPic} alt="Sooraj" className="rounded-3 mx-auto d-block mt-5  " />
                                </div>
                                <h3 className="col-12 text-center mt-5 mb-3 header-text">
                                   ورود به سامانه  بارسپار
                                </h3>
                                <hr className="w-50 m-auto my-3 text-secondary"/>
                                <div className="mt-3 px-5">
                                    <div className="form-floating mb-3">
                                        <input type="number" className="form-control" id="floatingInput"
                                               placeholder="name@example.com"
                                               value={this.state.mobile}
                                               onChange={this.onInputChange}
                                        />
                                            <label htmlFor="floatingInput">شماره همراه</label>
                                    </div>


                                </div>
                                <div className="w-100 fixed-bottom max-w-lg">
                                    <button onClick={this.onButtonClick} disabled={this.state.buttonStatus} type="submit"
                                            className="btn btn-primary w-100 py-2">
                                        {this.state.buttonText}
                                        <span  className={"spinner-grow spinner-grow-sm " + this.state.loading} role="status"
                                               aria-hidden="true"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
    componentDidMount() {

    }
}

export default Login;